import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { OnlineStatus, UserRole } from 'src/app/models/user';
import { IconConfig } from 'src/app/standalones/components/pencil-icon/pencil-icon.component';

@UntilDestroy()
@Component({
  selector: 'app-lightweight-user-avatar',
  templateUrl: './lightweight-user-avatar.component.html',
  styleUrls: ['./lightweight-user-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LightweightUserAvatarComponent implements OnChanges {
  @ViewChild('avatarContainer', { static: false }) avatarContainer?: ElementRef<HTMLElement>;

  @Input() width?: number;
  @Input() fontSize?: number;
  @Input() fontWeight?: number;
  @Input() fontColor?: string;
  @Input() highlightedText = '';
  @Input() showStatus?: boolean;
  @Input() userStatus?: OnlineStatus;
  @Input() opaqueOverlay = false;
  @Input() isInstitution = false;
  @Input() institutionLogo?: string;
  @Input() institutionName?: string;
  @Input() showName = false;
  @Input() showYouWord = false;
  @Input() imgScale = 1;
  @Input() enableImageBorder = false;
  @Input() parentDisplay?: string;
  @Input() imgBorder = false;
  @Input() showHostTag = false;
  @Input() isUser: boolean = false;
  @Input() profileImage?: string;
  @Input() userRole?: string;
  @Input() userEmail?: string;
  @Input() userName?: string;
  @Input() showAnimatedImageBorder = false;
  @Input() showSubtext = false;
  @Input() subText?: string;
  @Input() showBadge = false;
  @Input() badgeIconConfig?: IconConfig;

  OnlineStatusEnum = OnlineStatus;
  UserRoleEnum = UserRole;

  ngOnChanges(changes: SimpleChanges): void {
    if (
      !changes['showAnimatedImageBorder']?.firstChange &&
      changes['showAnimatedImageBorder']?.currentValue
    ) {
      this.avatarContainer?.nativeElement.style.removeProperty('animation');
      this.avatarContainer?.nativeElement.style.removeProperty('--progress');
    }
  }
  // remove the animation after it ends so it can't restart after any attribute change
  onBorderAnimationEnd(event: AnimationEvent): void {
    if (event.animationName === 'border-animate') {
      const element = event.target as HTMLElement;
      element.style.animation = 'none';
      element.style.setProperty('--progress', '100');
    }
  }

  /** Keep this component lightweight without service injections
   * It only shows user data with no added functionality
   * For more functions use `ProfilePhotoComponent`
   */
}
